/**
 * @file Search Dropdown.
 */

import { gsap } from 'gsap';

/**
 * Search dropdown.
 */
const vSearchDropdown = () => {
	const dropdown = document.querySelector('.v-search-dropdown');
	if (!dropdown) return;

	const page = document.querySelector('.full-body');
	const trigger = document.querySelector('.v-utility-nav__search-trigger');
	const wrap = dropdown.querySelector('.v-search-dropdown__wrap');
	const overlay = dropdown.querySelector('.v-search-dropdown__overlay');
	const label = dropdown.querySelector('.v-search-dropdown__overlay-label');

	let isAnimating = false;
	let isOpen = false;

	/**
	 * Open menu.
	 */
	const openMenu = () => {
		if (isAnimating) return;
		isAnimating = true;

		// a11y: update aria attributes
		if (trigger.getAttribute('aria-expanded') === 'false') {
			trigger.setAttribute('aria-expanded', true);
		}
		if (dropdown.getAttribute('aria-hidden') === 'true') {
			dropdown.setAttribute('aria-hidden', false);
		}

		dropdown.style.display = 'block';
		// label.style.display = 'block';
		gsap.timeline({
			onComplete: () => {
				dropdown.classList.add('open');
				page.classList.add('search-open');
				dropdown.removeAttribute('style');
				page.removeAttribute('style');
				wrap.removeAttribute('style');
				overlay.removeAttribute('style');
				isAnimating = false;
				isOpen = true;

				dropdown.focus();
			},
			defaults: {
				duration: 0.4,
			},
		})
			.to(dropdown, {
				translateY: 0,
			})
			.to(page, {
				paddingTop: 112,
			}, '<')
			.to(overlay, {
				opacity: 0.85,
			}, '<');
	};

	/**
	 * Close menu.
	 */
	const closeMenu = () => {
		if (isAnimating) return;
		isAnimating = true;

		// a11y: update aria attributes
		if (trigger.getAttribute('aria-expanded') === 'true') {
			trigger.setAttribute('aria-expanded', false);
		}
		if (dropdown.getAttribute('aria-hidden') === 'false') {
			dropdown.setAttribute('aria-hidden', true);
		}

		label.style.display = 'none';
		gsap.timeline({
			onComplete: () => {
				dropdown.classList.remove('open');
				page.classList.remove('search-open');
				dropdown.removeAttribute('style');
				page.removeAttribute('style');
				wrap.removeAttribute('style');
				overlay.removeAttribute('style');
				label.removeAttribute('style');
				isAnimating = false;
				isOpen = false;

				trigger.focus();
			},
			defaults: {
				duration: 0.4,
			},
		})
			.to(dropdown, {
				translateY: '-100%',
			})
			.to(page, {
				paddingTop: 0,
			}, '<')
			.to(overlay, {
				opacity: 0,
			}, '<');
	};

	trigger.addEventListener('click', openMenu);
	overlay.addEventListener('click', closeMenu);
	dropdown.addEventListener('focusout', () => {
		if (!isOpen) return;

		setTimeout(() => {
			if (
				dropdown.contains(document.activeElement)
        || document.activeElement === dropdown
			) return;
			closeMenu();
		}, 0);
	});
};

export default vSearchDropdown;
